import { PaymentSuccess } from "components/web-checkout/payment-success/payment-success";
import React from "react";
import Head from "next/head";
import { Main } from "styles/pages/web-checkout.styles";

const Success: React.FC = () => {
  return (
    <Main>
      <Head>
        <title>CoLearn | Pembayaran berhasil</title>
      </Head>
      <PaymentSuccess />
    </Main>
  );
};

export default Success;
